import { Chip, type ChipProps } from '@pets-ui/Chip/Chip'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  groupButton: {
    padding: '8px 12px',
  },
})

export interface CollapseProductChipProps extends ChipProps {
  isSelected: boolean
}

export const CollapseProductChip = ({ rootStyle, isSelected, ...rest }: CollapseProductChipProps) => {
  return (
    <Chip
      rootStyle={[styles.groupButton, rootStyle]}
      variant="square"
      color={isSelected ? 'primary' : 'default'}
      isOutlined
      isSoft={isSelected}
      size="medium"
      {...rest}
    />
  )
}
